module.exports = __webpack_public_path__ + "static/media/provider_icon.3f2602d3.svg";